/**
 * @description: request method
 */

export enum RequestEnum {
  // eslint-disable-next-line no-unused-vars
  GET = 'GET',
  // eslint-disable-next-line no-unused-vars
  POST = 'POST',
  // eslint-disable-next-line no-unused-vars
  PUT = 'PUT',
  // eslint-disable-next-line no-unused-vars
  DELETE = 'DELETE',
}

/**
 * @description:  contentType
 */
export enum ContentTypeEnum {
  // json
  // eslint-disable-next-line no-unused-vars
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  // eslint-disable-next-line no-unused-vars
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  // eslint-disable-next-line no-unused-vars
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}
